import { defineComponent, createElementBlock, openBlock, normalizeClass, createElementVNode, Fragment, renderList, createBlock, createCommentVNode, resolveDynamicComponent, withCtx, createTextVNode, toDisplayString } from 'vue';
import _sfc_main$1 from './basler-components.es129.js';
/* empty css                        */

const _hoisted_1 = {
  class: /* @__PURE__ */ normalizeClass(["tag-list-group"])
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TagListGroup",
  props: {
    items: {},
    headlineLevel: { default: 3 },
    onTagClick: {},
    onTagClose: {}
  },
  emits: ["tagClick", "tagClose"],
  setup(__props, { emit: __emit }) {
    const emit = __emit;
    const handleTagClick = (tag) => {
      emit("tagClick", tag);
    };
    const handleTagClose = (tag) => {
      emit("tagClose", tag);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        createElementVNode("ul", null, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (group, index) => {
            return openBlock(), createElementBlock("li", {
              class: "tag-list-group__item",
              key: index
            }, [
              group && group.title ? (openBlock(), createBlock(resolveDynamicComponent(`h${_ctx.headlineLevel}`), {
                key: 0,
                class: "tag-list-group__item-title"
              }, {
                default: withCtx(() => [
                  createTextVNode(toDisplayString(group.title), 1)
                ]),
                _: 2
              }, 1024)) : createCommentVNode("", true),
              group && group.tags ? (openBlock(), createBlock(_sfc_main$1, {
                key: 1,
                tags: group.tags,
                size: "medium",
                alignment: group?.alignment,
                class: "tag-list-group__item-tags",
                onClick: handleTagClick,
                onClose: handleTagClose
              }, null, 8, ["tags", "alignment"])) : createCommentVNode("", true)
            ]);
          }), 128))
        ])
      ]);
    };
  }
});

export { _sfc_main as default };
